import React, { useEffect, useState, useMemo, useContext } from "react";
import PropTypes from "prop-types";
import { useMsal } from "@azure/msal-react";
import CustomizedTable from "../CustomizedTable/CustomizedTable";
import { DefaultCell } from "../CustomizedTable/CustomCells/CustomCells";
import DateTimeRangeCell from "../CustomizedTable/CustomCells/DateTimeRangeCell/DateTimeRangeCell";
import DateRangeFilter from "../CustomizedTable/Filters/DateRangeFilter/DateRangeFilter";
import PrimaryTextField from "../Inputs/PrimaryTextField/PrimaryTextField";
import { SecurityService } from "../../services/SecurityService";
import { AlertContext } from "../Dashboard/Dashboard";

export default function AuditLog({ userId }) {
  const { instance } = useMsal();
  const { warning } = useContext(AlertContext);
  const [logs, setLogs] = useState([]);
  const [search, setSearch] = useState("");

  const columns = useMemo(
    () => [
      {
        Header: "Time",
        accessor: "timeStampTime",
        filter: "fuzzyText",
        timeOnly: true,
        width: 120,
        Cell: DateTimeRangeCell,
      },
      {
        Header: "Date",
        accessor: "timeStamp",
        Filter: DateRangeFilter,
        filter: "dateBetween",
        dateOnly: true,
        width: 120,
        Cell: DateTimeRangeCell
      },
      {
        Header: "Section",
        accessor: "componentName",
        filter: "fuzzyText",
        width: 300,
        Cell: DefaultCell,
      },
      {
        Header: "Actions",
        accessor: "action",
        filter: "fuzzyText",
        width: 500,
        Cell: DefaultCell,
      }
    ]
  );

  useEffect(() => {
    if (userId) {
      SecurityService.GetAuditLogs(instance, userId).then(res => {
        setLogs(res);
      }).catch(error => {
        console.error(error);
        warning(error);
      });
    }
  }, [userId]);

  return (
    <>
      <div style={{ display: "flex", justifyContent: "end", margin: "10px 24px" }}>
        <PrimaryTextField
          placeholder={`Search ${logs.length} results`}
          onChange={setSearch}
          value={search}
          isSearch
        />
      </div>
      <CustomizedTable
        id="audit-logs"
        columns={columns}
        data={logs}
        tableSearch={search}
      />
    </>
  );
}

AuditLog.propTypes = {
  userId: PropTypes.string
};